import React from 'react';
import { ButtonLabel, ButtonStyled } from '../../styledComponents';
import back from '../../images/back.svg';

export type ButtonType = 'secondary' | 'tiny' | 'link' | 'back';

interface Props {
	onClick: () => void;
	label: string;
	buttonType?: ButtonType;
	disabled?: boolean;
}

function Button(props: Props) {
	const { onClick, label, buttonType, disabled } = props;
	return (
		<ButtonStyled buttonType={buttonType} disabled={disabled || false} onClick={onClick}>
			{buttonType === 'back' && <img src={back} alt="" />}
			<ButtonLabel> {label || ''}</ButtonLabel>
		</ButtonStyled>
	);
}

export default Button;
